/* this is the action that loads all the data related to a widget
 *
 */
async function getWidgetData () {
    // load the following
    // widget
    // langauge
    // schedules
}

export default getWidgetData;